
<template>
    <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
        <template slot="no-body">

            <div v-if="item.image" class="item-img-container bg-white h-64 flex items-center justify-center mb-4" >
                <img :src="item.image" :alt="item.name_english" class="grid-view-img" >
            </div>
                <div v-else class="mt-5">
            </div>
            <div class="item-details px-4">
                <div class="flex justify-between items-center">
                    <div class="text-warning border border-solid border-warning flex py-1 px-2 rounded">
                        <span class="text-sm">{{$store.state.getLabel($store.state.language).saiKung}}</span>
                    </div>
                    <h6 class="font-bold text-sm">{{item.type.join(",")}}</h6>
                </div>

                <div class=" flex justify-between items-center">
                    <h6 class="truncate font-semibold mb-1 hover:text-primary mb-2">{{item.name_chi }}</h6>
                     <!-- <div v-if="item.rId === 37" class="" >
                        <img src="../assets/off.png" :alt="item.name_english" class="off" >
                    </div> -->
                </div>
                    <div class="my-4">
                    <p class="item-description truncate text-sm mb-2" style="white-space: pre-line;">{{ item.location_chi }}</p>
                    
                    
                    <span class="text-primary text-sm">{{$store.state.getLabel($store.state.language).min}}：$60</span>
                </div>
            </div>
            <slot name="action-buttons" />
        </template>
    </vx-card>
</template>

<script>
export default{
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    methods: {
      navigate_to_detail_view() {
        this.$router.push({name: 'ecommerce-item-detail-view', params: {item_id: this.item.objectID }})
          .catch(() => {})
      }
    }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
.off{
    max-width: 50px;
    max-height: 50px;
    z-index:10000;
}
</style>
